const mediaItems = [
  {
    title: '《斗罗大陆》动画联动专题',
    desc: '动画与漫画双线并进，带你深度了解斗罗世界观的完整架构，漫画细节更丰富。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20animation%20scene%20with%20martial%20arts%20hero%20flying%20through%20sky%2C%20blue%20spirit%20rings%20glowing%2C%20dynamic%20action%20composition%2C%20warm%20coral%20and%20golden%20accents%2C%20cinematic%20manga-style%20illustration%2C%20soft%20cream%20background%20with%20energy%20effects&width=800&height=500&seq=media-01-douluo-anime&orientation=landscape',
    icon: 'ri-play-circle-line',
  },
  {
    title: '国漫崛起：新生代漫画家推荐',
    desc: '一批才华横溢的国产漫画家正在崛起，他们的作品兼具东方美学与现代叙事，值得关注。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20studio%20scene%20with%20drawing%20tablet%20displaying%20Chinese%20manhua%20artwork%2C%20sketch%20pages%20scattered%20around%2C%20warm%20amber%20lighting%2C%20creative%20atmosphere%2C%20clean%20minimal%20workspace%2C%20professional%20artist%20environment%2C%20soft%20cream%20tones&width=800&height=500&seq=media-02-guoman-artist&orientation=landscape',
    icon: 'ri-palette-line',
  },
  {
    title: '下拉式阅读 vs 传统翻页对比',
    desc: '为什么越来越多的漫画平台转向下拉式阅读？一张图看懂两种阅读模式的差异。',
    img: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20smartphones%20showing%20different%20comic%20reading%20modes%2C%20vertical%20scroll%20versus%20page%20flip%2C%20warm%20coral%20and%20amber%20theme%2C%20clean%20product%20photography%20style%2C%20soft%20cream%20background%2C%20modern%20UI%20design&width=800&height=500&seq=media-03-compare&orientation=landscape',
    icon: 'ri-contrast-2-line',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">漫画圈热门内容与深入解读</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article key={item.title} className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/70">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`羞羞歪歪漫画 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-background-50/80 text-primary-600 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}